<span
  class="app-mat-icon material-symbols-rounded"
  [attr.aria-hidden]="ariaHidden"
  aria-hidden="true"
>
  {{ iconName }}
</span>
